export default __webpack_public_path__ + "static/media/multiple-users-silhouette.0d981fd6.svg";